'use strict';

module.exports = function () {
    // Tooltip code from sfra
    const $docment = $(document);
    $docment.on('touchstart mouseenter focusin', '.info-icon', function () {
        $(this).find('.tooltip').removeClass('d-none');
    });

    // Tooltip code from sfra
    $docment.on('mouseleave focusout', '.info-icon', function () {
        $(this).find('.tooltip').addClass('d-none');
    });

    // Add new event for closing tooltip on click of close icon
    $docment.on('click', '.tooltip .close-icon', function () {
        $(this).closest('.tooltip').addClass('d-none');
    });
};
